module.exports = __webpack_public_path__ + "components/flag/static/square/sk-ed04af2cc1854658ac73431d4f7253d5.svg";